import { PropsWithChildren } from 'react'

import { ObjectField } from '@formily/react'
import { isNil } from 'lodash'

import {
  BaseEditableTableRowProps,
  VirtualEditableTableRowProps
} from './interface'

/**
 * 为每一个单元格里面的 Field 添加 ObjectField 父节点
 */

const BaseEditableTableRow = ({
  index,
  children,
  ...restProps
}: PropsWithChildren<BaseEditableTableRowProps>) => {
  const isTheadRow = isNil(index)
  return (
    <tr {...restProps}>
      {isTheadRow ? (
        children
      ) : (
        <ObjectField name={index}>{children}</ObjectField>
      )}
    </tr>
  )
}
const VirtualEditableTableRow = ({
  index,
  children,
  ...restProps
}: PropsWithChildren<VirtualEditableTableRowProps>) => {
  const isTheadRow = isNil(index)
  return (
    <div {...restProps}>
      {isTheadRow ? (
        children
      ) : (
        <ObjectField name={index}>{children}</ObjectField>
      )}
    </div>
  )
}

export const EditableTableRow = Object.assign(BaseEditableTableRow, {
  Virtual: VirtualEditableTableRow
})
